import { axiosSwagger } from "@/axios";
import _orderBy from 'lodash/orderBy';

export const state = {
    campus: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
    allCampus: (state) => state.campus.data,
}


export const mutations = {
    // CAMPUS
    campusLoading: (state, loading) => {
        state.campus.loading = loading;
    },
    setCampusData: (state, data) => {
        state.campus.data = _orderBy(data, [item => item.campusName.toLowerCase()], ['asc']);
    },
    setCampusTotal: (state, total) => {
        state.campus.total = total;
    },
    addCampus: (state, data) => {
        state.campus.data.push(data);
    },
    removeCampus: (state, id) => {
        state.campus.data = state.campus.data.filter((el) => el.id !== id);
    },
    updateCampus: (state, data) => {
        const index = state.campus.data.findIndex((item) => item.id === data.id);

        if (index !== -1) {
            state.campus.data[index].campusName = data.campusName;
            state.campus.data[index].shortName = data.shortName;
        }
    },
}


export const actions = {
    // CAMPUS
    async readCampus({ commit }) {
        commit("campusLoading", true);

        return await axiosSwagger
            .get("/api/Campus/All")
            .then((response) => {
                commit("setCampusData", response.data);
                commit("setCampusTotal", response.data.length);
                commit("campusLoading", false);

                return response;
            })
            .catch(() => {
                commit("campusLoading", false);
            });
    },
    // eslint-disable-next-line no-unused-vars
    async readCampusById({ commit }, id){
        return await axiosSwagger
            .get(`/api/Campus/${id}`)
            .then((response) => {

                return response;
        });
    },
    async createCampus({ commit }, data) {
        return await axiosSwagger
            .post("/api/Campus/Create", data)
            .then((response) => {
                commit("addCampus", response.data);

                return response;
            });
    },
    async deleteCampus({ commit }, id) {
        return await axiosSwagger.delete(`/api/Campus/${id}`).then((response) => {
            commit("removeCampus", id);

            return response;
        });
    },
    async updateCampus({ commit }, data) {
        return await axiosSwagger
            .put(`/api/Campus/${data.id}`, data)
            .then((response) => {
                commit("updateCampus", data);

                return response;
            });
    },
}